// import { useState } from "react";
// import * as service from "../../../api/eventCategory.api";

// export const useEventCategory = () => {
//   const [data, setData] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const loadCategoriesByOrganizer = async (companyId) => {
//     setLoading(true);
//     try {
//       const res = await service.fetchOrganizerEventCategories(companyId);
//       setCategories(res.data?.data || []);
//   } catch (error) {
//     setCategories([]);
//   }
//   };

//   const loadCategories = async (company_id) => {
//       setLoading(true);
//       const res = await service.fetchEventCategoriesTree({ company_id });
//       setData(res.data?.data || []);
//       setLoading(false);
//     };

//   return {
//     data,
//     loading,
//     categories,
//     loadCategoriesByOrganizer,
//     loadCategories,
//     addCategory: service.createEventCategory,
//     editCategory: service.updateEventCategory,
//     deleteCategory: service.deleteEventCategory,
//   };
// };
import { useState } from "react";
import * as service from "../../../api/eventCategory.api";

export const useEventCategory = () => {
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginationInfo, setPaginationInfo] = useState({
    totalCategories: 0,
    totalPages: 1,
  });

  const loadCategoriesByOrganizer = async (companyId) => {
    setLoading(true);
    try {
      const res = await service.fetchOrganizerEventCategories(companyId);
      setCategories(res.data?.data || []);
    } catch (error) {
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  const loadCategories = async (company_id, options = {}) => {
    setLoading(true);
    try {
      const res = await service.fetchEventCategoriesTree({
        company_id,
        page: options.page || 1,
        limit: options.limit || 10,
        search: options.search || "",
      });

      const payload = res?.data || {};
      const list =
        payload.categories ||
        payload.data?.categories ||
        payload.data ||
        (Array.isArray(payload) ? payload : []);

      setData(list);

      setPaginationInfo({
        totalCategories:
          payload.pagination?.totalCategories || payload.total || list.length,
        totalPages: payload.pagination?.totalPages || payload.totalPages || 1,
      });
    } catch (error) {
      console.error("Failed to load event category tree:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    loading,
    categories,
    paginationInfo,
    loadCategoriesByOrganizer,
    loadCategories,
    addCategory: service.createEventCategory,
    editCategory: service.updateEventCategory,
    deleteCategory: service.deleteEventCategory,
  };
};